// Our main CSS
import '../css/app.css'

import { ModuleManager } from './moduleManager'
import Submenu from './modules/submenu'

new Submenu()

// Create and configure module manager
const moduleManager = new ModuleManager()

// Register all modules with their selectors
moduleManager
  .register('.js-image-gallery', 'imageGallery')
  .register('.js-office-list', 'officeList')
  .register('.js-expandable-sections', 'expandableSections')
  .register('.js-job-list', 'jobList')
  .register('.js-news-archive', 'newsArchive')
  .register('.js-search-results', 'searchResults')

  .registerAdmin('ImageGallery', 'imageGallery')
  .registerAdmin('OfficeList', 'officeList')
  .registerAdmin('ExpandableSections', 'expandableSections')
  .registerAdmin('JobList', 'jobList')
  .registerAdmin('NewsArchive', 'newsArchive')
  .registerAdmin('SearchResults', 'searchResults')

// Initialize modules
moduleManager.init()

// Create initializer functions on window object
Object.keys(moduleManager.adminModules).forEach((name) => {
  const modulePath = moduleManager.adminModules[name]
  window[`init${name}`] = () => moduleManager.loadModule(modulePath)
})

/**
 * 🦄: Now do your magic.
 */

const menuToggles = document.querySelectorAll('.menu-toggle')
const overlayMenu = document.querySelector('.overlay-menu')

// Handler for menu toggle clicks
const toggleOverlayMenu = () => {
  overlayMenu.classList.toggle('visible')
  const isVisible = overlayMenu.classList.contains('visible')

  if (isVisible) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = ''
  }
}

menuToggles.forEach((toggle) => {
  toggle.addEventListener('click', toggleOverlayMenu)
})

// Mobile submenu accordion functionality
const mobileSubmenuToggles = document.querySelectorAll('.mobile-submenu-toggle')

mobileSubmenuToggles.forEach((toggle) => {
  toggle.addEventListener('click', () => {
    const wrapper = toggle.closest('.mobile-submenu-wrapper')
    const content = wrapper.querySelector('.mobile-submenu-content')
    const arrow = toggle.querySelector('.mobile-submenu-arrow')
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true'

    if (isExpanded) {
      // Close the submenu
      content.style.maxHeight = '0'
      toggle.setAttribute('aria-expanded', 'false')
      arrow.style.transform = 'rotate(0deg)'
    } else {
      // Close all other submenus first
      mobileSubmenuToggles.forEach((otherToggle) => {
        if (otherToggle !== toggle) {
          const otherWrapper = otherToggle.closest('.mobile-submenu-wrapper')
          const otherContent = otherWrapper.querySelector('.mobile-submenu-content')
          const otherArrow = otherToggle.querySelector('.mobile-submenu-arrow')
          otherContent.style.maxHeight = '0'
          otherToggle.setAttribute('aria-expanded', 'false')
          otherArrow.style.transform = 'rotate(0deg)'
        }
      })

      // Open this submenu
      content.style.maxHeight = content.scrollHeight + 'px'
      toggle.setAttribute('aria-expanded', 'true')
      arrow.style.transform = 'rotate(-180deg)'
    }
  })
})

// Search form toggle functionality
const searchToggles = document.querySelectorAll('.js-toggle-search')
const searchForm = document.querySelector('.js-search-form')

if (searchToggles.length > 0 && searchForm) {
  // Initially hide the search form
  searchForm.style.height = '0'
  searchForm.style.overflow = 'hidden'
  searchForm.style.transition = 'height 0.3s ease-in-out'

  const toggleSearchForm = () => {
    const isVisible = searchForm.style.height !== '0px' && searchForm.style.height !== ''

    // Always close the overlay menu when toggling search
    if (overlayMenu && overlayMenu.classList.contains('visible')) {
      overlayMenu.classList.remove('visible')
      document.body.style.overflow = ''
    }

    if (isVisible) {
      // Hide the search form
      searchForm.style.height = '0'
    } else {
      // Show the search form
      searchForm.style.height = '150px'
    }
  }

  searchToggles.forEach((toggle) => {
    toggle.addEventListener('click', toggleSearchForm)
  })

  // Close search form when clicking outside of it
  document.addEventListener('click', (event) => {
    const isVisible = searchForm.style.height !== '0px' && searchForm.style.height !== ''

    if (isVisible) {
      // Check if the click was outside the search form and not on a search toggle
      const isClickOutsideSearch = !searchForm.contains(event.target)
      const isClickOnToggle = Array.from(searchToggles).some((toggle) =>
        toggle.contains(event.target)
      )

      if (isClickOutsideSearch && !isClickOnToggle) {
        searchForm.style.height = '0'
      }
    }
  })
}
